import {Component, OnInit, Inject} from '@angular/core';
import { MsalBroadcastService, MsalGuardConfiguration, MsalService, MSAL_GUARD_CONFIG } from '@azure/msal-angular';
import {NeqHttpClient} from '@sharedrest/http-client.config';
import { InteractionStatus, RedirectRequest } from '@azure/msal-browser';
import { AuthenticationService } from '@usercommon/service/authentication.service';
import { filter, take } from 'rxjs/operators';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { PatchDto, UserServiceClient } from '@sharedcommon/rest/identity.restservice';
import { NeqDialogService } from '@sharedcommon/services/dialog.service';
import {UserService} from '@sharedcommon/services/user.service';

@Component({
  selector: 'neq-login-page',
  templateUrl: './login.page.html'
})
export class NeqLoginPage implements OnInit {

  appVersion: string;
  loginDisable: boolean;

  constructor(
    @Inject(MSAL_GUARD_CONFIG) private readonly msalGuardConfig: MsalGuardConfiguration,
    private readonly authService: AuthenticationService,
    private readonly authMsalService: MsalService,
    private readonly msalBroadcastService: MsalBroadcastService,
    private readonly router: Router,
    protected httpClient: NeqHttpClient,
    private readonly cookieService: CookieService,
    private readonly userServiceClient: UserServiceClient,
    private readonly userService: UserService,
    private readonly dialogService: NeqDialogService) {
      this.userService.manageLang(true);
    }

  ngOnInit() {
    this.loginDisable = true;
      this.msalBroadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None),
        take(1)
      )
      .subscribe(() => {
        const azureAccount = this.authService.setAndGetAzureAccount();
        if (azureAccount) {
          const claims: any = azureAccount.idTokenClaims;
          const claimsValidation = this.authService.validateClaims(claims);
          if (!claimsValidation.valid) {
            this.router.navigate(['/error'], { queryParams: { reason: claimsValidation.error } });
              return;
            }

          this.userService.setUser(claims);
          this.userService.changeLang();

              this.termsAcceptanceTreatment(claims);
          this.router.navigate(['/']);
        } else {
          this.loginDisable = false;
        }
      });
  }

  onClick() {
    localStorage.clear();
    this.loginDisable = true;
    const authRequest = {...this.msalGuardConfig.authRequest };
    this.authMsalService.loginRedirect({
      redirectStartPage: this.authService.redirectUrl,
      ...authRequest
    } as RedirectRequest);
  }

  transferCookieToDb () {
    const cookieTermsAcceptance = this.cookieService.get('termsAcceptance');
    const cookiePersonalDataAcceptance = this.cookieService.get('personalDataAcceptance');

    if (cookieTermsAcceptance !== null && cookieTermsAcceptance != "null") {
      let valueToSendPersonalDataAcceptance;
      if (cookiePersonalDataAcceptance !== null && cookiePersonalDataAcceptance != "null") {
        valueToSendPersonalDataAcceptance = new Date(Number.parseInt(cookiePersonalDataAcceptance, 10));
      } else {
        valueToSendPersonalDataAcceptance = "null";
      }

      const patch: PatchDto<any>[] = [
        {op: 'REPLACE', path: '/gdprAccept', value: [new Date(Number.parseInt(cookieTermsAcceptance, 10)), valueToSendPersonalDataAcceptance]}
      ];

      // save terms acceptance and personal data acceptance on db
      this.userServiceClient.patchCurrentUser(patch).subscribe(() => {
        this.router.navigate(['']);
      });
    }
  }

  /**
   * The terms acceptance treatment
   * @param claims the claims
   * @returns
   */
  termsAcceptanceTreatment(claims) {
    let terms_acceptance = (claims.extension_user_terms_acc as string).substring(1);
    let lang_code = claims.extension_user_lang as string

    if ((terms_acceptance !== null) && (terms_acceptance !== "")) {
      this.router.navigate(['/']);
      return;
    } else if (this.cookieService.check('termsAcceptance')) {
      this.transferCookieToDb();
      return;
    }

    let html = '';
    if (lang_code.toLowerCase() == 'fr') {
      html = '<h1>Réglement Général sur la Protection des Données personnelles au sein de MatrixNutri</h1>\n'
      + 'J\'accepte les <a href="https://www.compliance.adm.com/documents/terms-of-use/" rel="noopener" target="_blank">Conditions Générales d\'Utilisation</a>, '
      + 'et j\'ai lu et compris la <a href="https://www.compliance.adm.com/documents/privacy-notice-for-apps/" rel="noopener" target="_blank">Confidentialité des données personnelles</a>.\n'
      + 'Veuillez accepter les Conditions Générales d\'Utilisation et prendre connaissance de la Confidentialité des données personnelles pour accéder à l\'application.\n'
      + 'J\'accepte qu\'ADM puisse stocker, utiliser et traiter mes données personnelles en m\'envoyant des communications ciblées à des fins de prospection.';
    } else {
      html = '<h1>General Regulation on the Protection of Personal Data within Equadvice</h1>\n'
      + 'I accept the <a href="https://www.compliance.adm.com/documents/terms-of-use/" rel="noopener" target="_blank">Terms of Use</a>, '
      + 'and have read and understood the <a href="https://www.compliance.adm.com/documents/privacy-notice-for-apps/" rel="noopener" target="_blank">Privacy Notice</a>.\n'
      + 'Please accept the Terms of Use and acknowledge the Privacy Notice to access the application.\n'
      + 'I agree that ADM may store, use and process my personal data by sending me targeted communications for prospecting purposes.';
    }

    // Terms accpetance date not saved (on database and with cookie)
    const dialog = this.dialogService.showRgpd(html);

    dialog.afterClosed().subscribe((personalDataAcceptance) => {

      // Check if dialog box is canceled
      if (personalDataAcceptance == null) {
        this.router.navigate(['logout']);
        return;
      }

      let valueToSend = [];
      if (personalDataAcceptance){
        valueToSend = [new Date(), new Date()];
      } else {
        valueToSend = [new Date(), "null"];
      }

      const patch: PatchDto<any>[] = [
        {op: 'REPLACE', path: '/gdprAccept', value: valueToSend}
      ];

      // save terms acceptance and personal data acceptance on db
      this.userServiceClient.patchCurrentUser(patch).subscribe(() => {
        this.router.navigate(['']);
      });
    });
  }
}
